import { render } from "./Numeric.vue?vue&type=template&id=19ba4e20&scoped=true"
import script from "./Numeric.vue?vue&type=script&lang=js"
export * from "./Numeric.vue?vue&type=script&lang=js"

import "./Numeric.vue?vue&type=style&index=0&id=19ba4e20&lang=scss&scoped=true"

import exportComponent from "/app/tmp/origina/V3/v2026.18.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ba4e20"]])

export default __exports__